import React from 'react'

export default function MeetingBigimage({bigImage}) {
  return (
    <>
    <section className="meetpage-bigimage wow animate__animated animate__fadeInUp" data-wow-duration="1.1s" >
        <img src={bigImage?.image} alt="meeting" className="img-responsive" loading="lazy"/>
    </section>
    </>
  )
}
